// extracted by mini-css-extract-plugin
export default {"background":"profileLayout_background__HXHaT"};